import React from 'react'
import { useFormContext, useWatch } from 'react-hook-form';
import ControlSwitch from '@/Shared/Form/ControlSwitch';
import CountriesSelect from './CountriesSelect';
import LegalBasis from './LegalBasis';

const PersonalDataToThirdCountries = () => {
  const { control } = useFormContext();
  const isSelected = useWatch({ name: 'isPersonalDataTransferedToThirdCountry', control });

  return (
    <React.Fragment>
      <div className="mb-3">
        <ControlSwitch
          labelOff='No'
          labelOn='Yes'
          name='isPersonalDataTransferedToThirdCountry'
        />
      </div>
      {isSelected && (
        <React.Fragment>
          <CountriesSelect />
          <LegalBasis />
        </React.Fragment>
        
      )}
    </React.Fragment>
  )
}

export default PersonalDataToThirdCountries